import PaymentForm from "./PaymentForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const PUBLIC_KEY = "pk_test_51IRTpkDr8IvH6iicoF3TZnpfPSRfXaErA6IMAxBRRI8dCUFEMXar8FjevSDSMCZks28FrujMwVYv06sk9eA9pWHk00VhYPNYOT";

const stripePromise = loadStripe(PUBLIC_KEY);

function Payment({ price }) {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm price={price} />
    </Elements>
  );
}

export default Payment;
